import React from 'react'

export interface ChevronUpProps {
  size?: number
  color?: string
}

export const ChevronUp: React.FC<ChevronUpProps> = ({
  size = 24,
  color = '#ffffff',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 15L12 9L6 15"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
